import { createRoot } from 'react-dom/client'
import App from './App'

document.addEventListener('DOMContentLoaded', function () {
	const container = document.getElementById('app-firmes-sant-jordi')
	const lang = document.documentElement.lang || 'ca'
	const year = new URLSearchParams(window.location.search).get('year') || container?.dataset.year || '2025'
	const preview = new URLSearchParams(window.location.search).get('preview') === '1'
	const root = createRoot(container)
	root.render(<App lang={lang} year={year} preview={preview} />)
})
